import React from 'react';
import './LoadingModal.css';

export const LoadingModal = ({ isLoading, children }) => {
  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {children}
      {isLoading && (
        <div className="loading-modal-overlay">
          <div className="loader-container">
            <div className="loader"></div>
            <span className="loader-text">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};